import React from 'react';
import ReactDOM from 'react-dom';
import { DivOverallWrap } from '../../../../react/components/utility/wrap';
import { CurrentUser, CurrentUserContext } from '../../../../react/providers/currentUser';
import { Props, CalcQuestionSetShow } from '../../../../react/pages/calc_question_sets/show/calcQuestionSetShow'

document.addEventListener('DOMContentLoaded', () => {
  const domToBinding = document.getElementById('calc-question-sets-show-root')!;
  if(domToBinding == null) return

  const currentUser:CurrentUser = JSON.parse(domToBinding.dataset.json!).currentUser;
  const props:Props = JSON.parse(domToBinding.dataset.json!);


  ReactDOM.render(
    <>
      <CurrentUserContext.Provider value={{...currentUser}}>
        <DivOverallWrap>
          <CalcQuestionSetShow {...props}/>
        </DivOverallWrap>
      </CurrentUserContext.Provider>
    </>,
    domToBinding);
});
